import { useState } from "react";
import { useRouteNavigation } from "./routes";
import { TOnboardingProgressStatus, TOnboardingMasterStep, TOnboardingSummary } from "../types/onboarding_types";
import { apiRequestSecureGet } from "./api";
import { useAuthContext } from "../../contexts/auth-context";

export const useOnboardingProcess = () => {
    const { getRoute } = useRouteNavigation();
    const { getUserTokenId } = useAuthContext();
    const [onboardingStatus, setOnboardingStatus] = useState<TOnboardingProgressStatus>();
    const [nextOnboardingStep, setNextOnboardingStep] = useState<TOnboardingMasterStep | null>();
    const [remainingSteps, setRemainingSteps] = useState<TOnboardingMasterStep[]>([]);

    const URLS = {
        onboardingProgress: "onboarding/progress_by_user_id",
    };

    const getOnboardingProgress = async (): Promise<TOnboardingSummary> => {
        const response = await apiRequestSecureGet<TOnboardingSummary>(URLS.onboardingProgress, await getUserTokenId());
        return response.data;
    };

    const step_candidate_labels = {
        verify_email: "Verify Email",
        verify_phone: "Verify Phone",
        upload_profile_photo: "Upload Photo",
        fill_contact_info: "Complete Contact Info",
        fill_personal_profile_info: "Complete Profile Info",
        fill_about_me: "About Me",
        fill_ideal_job: "Ideal Job",
        add_hobbies: "Add Hobbies",
        upload_background: "Upload Background",
        portfolio_gallery: "Upload Portfolio",
        fill_education: "Add Education",
        fill_experience: "Add Experience",
    };

    const step_company_labels = {
        verify_email: "Verify Email",
        verify_phone: "Verify Phone",
        upload_logo: "Upload Logo",
        fill_basic_info: "Complete Basic Info",
        fill_philosophy: "Add Philosophy",
        fill_about_area: "Describe Area",
        upload_background: "Upload Background",
        upload_office_exterior: "Office Exterior",
        upload_office_interior: "Office Interior",
        upload_video: "Upload Video",
        choose_lifestyle: "Choose Lifestyle",
        add_credit_card: "Add Credit Card",
        gallery_area: "Upload Gallery",
    };

    const company_special_steps_routes = {
        add_credit_card: getRoute("dentalLabSubscription"),
    };

    const refreshOnboardingProgress = async () => {
        const {
            data: { onboardingStatus, remainingSteps, nextStep },
        } = await getOnboardingProgress();
        setOnboardingStatus(onboardingStatus);
        setRemainingSteps(remainingSteps);
        setNextOnboardingStep(nextStep);
    };

    return {
        step_candidate_labels,
        refreshOnboardingProgress,
        onboardingStatus,
        nextOnboardingStep,
        remainingSteps,
        step_company_labels,
        company_special_steps_routes,
    };
};
